/* eslint-disable */
import "bootstrap/dist/css/bootstrap.min.css";
import TopNav from "./components/topNav/topNav.js";
import SideNav from "./components/sideNav/sideNav.js";
import MainContent from "./components/mainContent/mainContent.js";
import Footer from "./components/footer/footer.js";
import React, { createContext, useEffect, useState } from "react";
import { companyId, devMode, getUserInfo, host, locale, mmHost } from "./utils.js";
import { Routes, Route, Link } from "react-router-dom";
import Cookies from "js-cookie";
import axios from "axios";
import { ShowCase } from "./components/trinetra/trinetra.js";



export let AuthInfo = createContext();
export let ConfigContext = createContext();

function App() {
  let userId = Cookies.get("uId");
  let sessionId = Cookies.get("connect.sid");
  const [showLS, setShowLS] = useState(true);
  const [userInfo, setUserInfo] = useState({
    profile: {
      name: "-",
      gender: "-",
      picture: ""
    },
    employment: {
      designation: "-",
      type: "-",
      permissions: [],
      sdplants: [],
    },
    tokens: [],
    roles: [],
    machines: [],
    createdAt: "-",
    updatedAt: "-",
  });

  useEffect(async ()=>{
    if(!devMode){
      let {data} = await axios.get(getUserInfo(userId));
      setUserInfo(data)
    } 
  },[]);
  

  return (
    <>
      <ConfigContext.Provider value={{ companyId: companyId, mmHost: mmHost,locale:locale, host:host }}>
        <Routes>
          <Route path="/rx/">
            <Route
              path="base/*"
              element={
                <AuthInfo.Provider
                  value={{ userId: userId, permissions: "all_access",userInfo:userInfo }}
                >
                  <SideNav mmHost={mmHost}></SideNav>
                  <TopNav setShowLS={setShowLS}></TopNav>
                    <MainContent
                      userId={userId}
                      showLS={showLS}
                      setShowLS={setShowLS}
                    ></MainContent>
                  <Footer></Footer>
                </AuthInfo.Provider>
              }
            ></Route>

            <Route
              path="nosideNav/*"
              element={
                <AuthInfo.Provider
                  value={{ userId: userId, permissions: "all_access",userInfo:userInfo }}
                >
                  <TopNav setShowLS={setShowLS}></TopNav>
                    <MainContent
                      userId={userId}
                      showLS={showLS}
                      setShowLS={setShowLS}
                      noSideNav={true}
                    ></MainContent>
                  <Footer></Footer>
                </AuthInfo.Provider>
              }
            ></Route>

            <Route path="home" element={<h1>Home [App]</h1>}></Route>

            <Route path="" element={<h1>404 page not found [App]</h1>}></Route>

            <Route path="trinetra" element={<ShowCase></ShowCase>}></Route>
          </Route>
        </Routes>
      </ConfigContext.Provider>
    </>
  );
}

export function useAPI() {
  const context = useContext(AuthInfo);
  if (context === undefined) {
    throw new Error("Context must be used within a Provider");
  }
  return context;
}

export default App;
